import { get } from 'lodash';
import ChunkedPaginationUtils from '../../../../global/chunkedPaginationUtils.js';

const localCache = new ChunkedPaginationUtils(50, 50);

export const DEFAULT_STATE = {
    isFetching: false,
    results: [],
    total: 0,
    canLoadMore: false,
    needsToRequest: false,
    pageNumber: 0,
    pageSize: localCache.getPageSize(),
};

export default (state = DEFAULT_STATE, action) => {
    const first = get(action, 'callbackParams.first', true);

    switch (action.type) {
        case 'EventAttendeeActions.ON_BEFORE_GETFILTERED':
            return {
                ...(first ? DEFAULT_STATE : state),
                isFetching: first,
            };

        case 'EventAttendeeActions.ON_GETFILTERED':
            localCache.loadPage(
                action.result.attendees,
                action.result.total,
                first,
            );

        // eslint-disable-next-line no-fallthrough
        case 'EventAttendeeActions.ON_GET_NEXTPAGE': {
            return {
                isFetching: false,
                results: localCache.getAll(true),
                total: localCache.getTotalCount(),
                canLoadMore: localCache.canLoadMore(),
                needsToRequest: localCache.needsToLoadPage(),
                pageNumber: localCache.getCurrentPageNumber(),
                pageSize: localCache.getPageSize(),
            };
        }

        case 'EventAttendeeActions.ON_CLEARATTENDEES':
            return DEFAULT_STATE;

        default:
    }

    return state;
};
